import { render, staticRenderFns } from "./PxCamposCompraM8.vue?vue&type=template&id=f18b665e&"
import script from "./PxCamposCompraM8.vue?vue&type=script&lang=js&"
export * from "./PxCamposCompraM8.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports